import React, { Component } from 'react';
import Countdown from './components/Countdown.js';
import Game from './components/Game.js';
import TitleScreen from './components/TitleScreen.js';
import EndScreen from './components/EndScreen.js';
import './App.css';

class App extends Component {

constructor() {
	super();
	this.state = {stage: 0, winner: '', loser: '', wScore: 0, lScore: 0, tScore: 0, tie: false};
}

componentDidMount(){
  setTimeout(()=>{document.getElementById('AppTitle').style.fontSize='9rem';}, 100);
  setTimeout(()=>{document.getElementById('AppTitle').style.opacity=1;}, 500);

  var lastTouchEnd = 0;
  document.addEventListener('touchend', function (event) {
    var now = (new Date()).getTime();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);

  document.addEventListener('touchmove', function (event) {
    if (event.scale !== 1) { event.preventDefault(); }
  }, { passive: false });
}

nextStage() {
  this.setState(state => ({stage: state.stage += 1}));
}

reset() {
  this.setState(state => ({stage: state.stage = 1}));
  this.setState(state => ({winner: 0}));
  this.setState(state => ({wScore: 0}));
  this.setState(state => ({loser: 0}));
  this.setState(state => ({lScore: 0}));
  this.setState(state => ({tScore: 0}));
  this.setState(state => ({tie: false}));
}

winner(winner, loser, wScore, lScore) {
  this.setState(state => ({winner: winner}));
  this.setState(state => ({wScore: wScore}));
  this.setState(state => ({loser: loser}));
  this.setState(state => ({lScore: lScore}));
}

tie(score) {
  this.setState(state => ({tScore: score}));
  this.setState(state => ({tie: true}));
}

  render() {

    let stage = this.state.stage;

    return (
      <div className="App">
      {stage === 0? (
        <div className="appTop">
        <header className="App-header introSpin">
          <h1 className="App-title" id="AppTitle">Click <br/> Off!</h1>
        </header>
        <TitleScreen nextStage={this.nextStage.bind(this)} />
        </div> ) : (stage === 1? (
        <Countdown nextStage={this.nextStage.bind(this)} /> 
        ) : (stage === 2? (
        <Game nextStage={this.nextStage.bind(this)} winner={this.winner.bind(this)} tie={this.tie.bind(this)}/> 	
        ) : (
        <EndScreen 
        winner={this.state.winner} 
        wScore={this.state.wScore}
         loser={this.state.loser} 
        lScore={this.state.lScore}
        reset={this.reset.bind((this))}
        tie={this.state.tie}
        tScore={this.state.tScore}
        />))
      )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js